module.exports = __webpack_public_path__ + "img/edge_nature_panorama.1221ec60.svg";